import { render } from "./PendingInstituteActivationCard.vue?vue&type=template&id=faf9bff8"
import script from "./PendingInstituteActivationCard.vue?vue&type=script&lang=js"
export * from "./PendingInstituteActivationCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PendingInstituteActivationCard.vue"]])

export default __exports__